import { Typographies } from '@/theme';
import { Box, styled } from '@mui/material';

interface RolesSelectorStyledProps {
  selected: boolean;
}

export const RadioPanelStyled = styled(Box)<RolesSelectorStyledProps>(
  ({ theme, selected }) => ({
    borderRadius: theme.spacing(1),
    background: selected
      ? theme.palette.primary.main
      : theme.palette.dark.dark_6,
    display: 'block',
    width: '100%',
    padding: theme.spacing(1),
    textAlign: 'center',
    color: selected ? theme.palette.white.main : theme.palette.dark.dark_4,
    fontWeight: Typographies.FONT_WEIGHT_BODY,
    fontSize: Typographies.FONT_SIZE_INPUTS,
    cursor: 'pointer',
  }),
);
